<app-error-message [errorMessage]="error"></app-error-message>    
<app-spinner size="3x" *ngIf="!loaded && !error"></app-spinner>
<div *ngIf="!error" id="vizContainer"></div>
